import { render, staticRenderFns } from "./page-community.vue?vue&type=template&id=14bf239d&scoped=true&"
import script from "./page-community.vue?vue&type=script&lang=js&"
export * from "./page-community.vue?vue&type=script&lang=js&"
import style0 from "./page-community.vue?vue&type=style&index=0&id=14bf239d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf239d",
  null
  
)

export default component.exports